import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Eye, User } from 'lucide-react';
import { useAdminImpersonation } from '@/contexts/AdminImpersonationContext';
import { useNavigate } from 'react-router-dom';

const AdminImpersonationBanner: React.FC = () => {
  const { impersonatedProfile, originalUser, stopImpersonation, isImpersonating } = useAdminImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedProfile || !originalUser) {
    return null;
  }

  const handleViewDashboard = () => {
    navigate('/athlete-dashboard');
  };

  return (
    <div className="bg-yellow-500 text-black px-4 py-3 shadow-lg border-b border-yellow-600 z-50 sticky top-0">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <Eye className="h-5 w-5" />
          <span className="font-semibold">
            Admin View: Viewing as <strong>{impersonatedProfile.name || impersonatedProfile.email}</strong>
          </span>
          <span className="text-sm opacity-80">
            ({impersonatedProfile.role})
          </span>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleViewDashboard}
            className="bg-blue-600 text-white hover:bg-blue-700 border-blue-600 font-semibold"
          >
            <User className="h-4 w-4 mr-2" />
            View Dashboard
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={stopImpersonation}
            className="bg-black text-yellow-500 hover:bg-gray-800 border-black font-semibold"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Switch Back to Admin
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminImpersonationBanner;